module.exports = __webpack_public_path__ + "static/media/googlehome-scenario.38d7166c.png";